import { Dispatch, SetStateAction } from "react";
import { IonLabel, IonToggle } from "@ionic/react";

import { translate } from "~utils";

type WaitlistAutoFillFieldProps = {
  value: boolean;
  onChange: Dispatch<SetStateAction<boolean>>;
};

export function WaitlistAutoFillField(props: WaitlistAutoFillFieldProps) {
  const { value, onChange } = props;

  return (
    <div
      css={{
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
      }}
    >
      <div>
        <IonLabel className="font-medium">{translate("WAITLIST_AUTO_FILL_HEADER")}</IonLabel>
        <br />
        <IonLabel css={{ fontSize: 14, marginTop: 8 }}>
          {translate("WAITLIST_AUTO_FILL_LABEL")}
        </IonLabel>
      </div>
      <IonToggle
        aria-label="Lesson Plan Provided toggle"
        slot="end"
        checked={value}
        onIonChange={(e: CustomEvent) => onChange(e.detail.checked)}
      />
    </div>
  );
}
